import EnvironmentSelector_vue_vue_type_script_setup_true_lang_default from "./EnvironmentSelector.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/scalar-address-bar-block/components/EnvironmentSelector.vue
var EnvironmentSelector_default = EnvironmentSelector_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { EnvironmentSelector_default as default };

//# sourceMappingURL=EnvironmentSelector.vue.js.map